import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconContentCopySvg } from "./IconContentCopySvg.mjs";
const IconContentCopy = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconContentCopySvg, ...iconProps });
};
export {
  IconContentCopy
};
